import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";
import EventBus from "../../utils/EventBus";
import PRODUCTAPI from "../../Api/ProductApi";



export const fetchProducts = createAsyncThunk("/fetchProducts", async (params, thunkAPI) => {
    try {
        const response = await PRODUCTAPI.getProducts(params);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const fetchProductsById = createAsyncThunk("/fetchProducts", async (id, thunkAPI) => {
    try {
        const response = await PRODUCTAPI.getProductsById(id);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});



export const addProduct = createAsyncThunk("/add", async (formData, thunkAPI) => {
    try {
        const response = await PRODUCTAPI.addProduct(formData);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});
export const confirmProduct = createAsyncThunk("/add", async (formData, thunkAPI) => {
    try {
        const response = await PRODUCTAPI.confirmProduct(formData);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});



export const updateProduct = createAsyncThunk("/update", async ({ id, formData }, thunkAPI) => {
    try {
        const response = await PRODUCTAPI.updateProduct(id, formData);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});


export const deleteProduct = createAsyncThunk("/delete", async (id, thunkAPI) => {
    try {
        const response = await PRODUCTAPI.deleteProduct(id);
        return id;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

const ProductReducer = createSlice({
    name: "Product",
    initialState: {
        Products:[],
        error: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProducts.fulfilled, (state, action) => {
                state.Products = action.payload.data;
            })
            .addCase(updateProduct.fulfilled, (state, action) => {
                const {
                    arg: { id },
                } = action.meta;
                console.log(action.payload)
                if (id) {
                    state.Products = state.Products.map((p) =>
                        p._id === id ? action.payload.data : p
                    );
                }
            })
            .addCase(deleteProduct.fulfilled, (state, action) => {
                state.Products = state.Products.filter((p) => p.id !== action.payload);
            })
            .addCase(fetchProducts.rejected, (state, action) => {
                state.Products=[]
                state.error = action.payload;
            })
            .addCase(addProduct.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(updateProduct.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(deleteProduct.rejected, (state, action) => {
                state.error = action.payload;
            });
    },
});

const { reducer } = ProductReducer;
export default reducer;
